import { render, staticRenderFns } from "./AppScoresNCAAB.vue?vue&type=template&id=917237b4&"
import script from "./AppScoresNCAAB.vue?vue&type=script&lang=js&"
export * from "./AppScoresNCAAB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports